import { useEffect } from 'react';

/**
 * Popup-only landing page for the Slack OAuth redirect. Reads `code`/`state`
 * (or `error`) off the URL, hands them back to the opener window via
 * `postMessage` (matched in `src/lib/slack.ts`), then closes itself. Never
 * rendered as a real page — the opener drives the actual "connect a
 * workspace" UI.
 */
export function SlackCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    window.opener?.postMessage(
      {
        source: 'mithril-slack-callback',
        code: params.get('code') ?? undefined,
        state: params.get('state') ?? undefined,
        error: params.get('error') ?? undefined,
      },
      window.location.origin,
    );
    window.close();
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        fontFamily: 'var(--mono)',
        fontSize: '0.8rem',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: 'var(--color-text-muted)',
      }}
    >
      Connecting…
    </div>
  );
}
